import { render } from "./DiscountOffer.vue?vue&type=template&id=497cdfcc&scoped=true"
import script from "./DiscountOffer.vue?vue&type=script&lang=js"
export * from "./DiscountOffer.vue?vue&type=script&lang=js"

import "./DiscountOffer.vue?vue&type=style&index=0&id=497cdfcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497cdfcc"]])

export default __exports__